import { render, staticRenderFns } from "./SearchPageSj.vue?vue&type=template&id=1314cc2e&scoped=true&"
import script from "./SearchPageSj.vue?vue&type=script&lang=js&"
export * from "./SearchPageSj.vue?vue&type=script&lang=js&"
import style0 from "./SearchPageSj.vue?vue&type=style&index=0&id=1314cc2e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1314cc2e",
  null
  
)

export default component.exports